
        <div class="min-h-screen bg-[color:var(--background)] flex items-center justify-center pt-24 pb-16 px-4 sm:px-6 lg:px-8 text-[color:var(--foreground)]">
            <div class="max-w-md w-full space-y-8 text-slate-900">
                <div class="flex flex-col items-center">
                    <a routerLink="/" class="mb-4">
                        <div class="h-14 px-5 flex items-center justify-center">
                            <img [src]="logoSrc" alt="nibni" class="h-9 w-auto object-contain select-none" />
                        </div>
                    </a>
                    <h2 class="text-3xl font-bold text-slate-900 text-center">Create Investor Account</h2>
                    <p class="text-slate-600 text-center">Looking for properties to buy</p>
                </div>

                <form [formGroup]="form" (ngSubmit)="submit()" class="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm space-y-4">
                    <div class="grid gap-4 sm:grid-cols-2">
                        <label class="space-y-1 block">
                            <span class="text-sm text-slate-600">First name</span>
                            <input
                                formControlName="first_name"
                                type="text"
                                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            />
                            <span *ngIf="fieldErrors['first_name']" class="text-red-600 text-xs">{{ fieldErrors['first_name'] }}</span>
                        </label>

                        <label class="space-y-1 block">
                            <span class="text-sm text-slate-600">Last name</span>
                            <input
                                formControlName="last_name"
                                type="text"
                                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            />
                            <span *ngIf="fieldErrors['last_name']" class="text-red-600 text-xs">{{ fieldErrors['last_name'] }}</span>
                        </label>
                    </div>

                    <label class="space-y-1 block">
                        <span class="text-sm text-slate-600">Email</span>
                        <input
                            formControlName="email_id"
                            type="email"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                        />
                        <span *ngIf="fieldErrors['email_id']" class="text-red-600 text-xs">{{ fieldErrors['email_id'] }}</span>
                    </label>

                    <app-phone-input formControlName="mobile"></app-phone-input>
                    <span *ngIf="fieldErrors['mobile']" class="text-red-600 text-xs">{{ fieldErrors['mobile'] }}</span>

                    <label class="space-y-1 block">
                        <span class="text-sm text-slate-600">Password</span>
                        <div class="relative">
                            <input
                                formControlName="password"
                                [type]="showPassword ? 'text' : 'password'"
                                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 pr-11 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            />
                            <button
                                type="button"
                                (click)="showPassword = !showPassword"
                                class="absolute inset-y-0 right-2 flex items-center justify-center rounded-md px-2 text-slate-500 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#6e9bad]/30"
                                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                                [attr.aria-pressed]="showPassword"
                            >
                                <lucide-icon [name]="showPassword ? 'eye-off' : 'eye'" class="h-4 w-4"></lucide-icon>
                            </button>
                        </div>
                        <span *ngIf="fieldErrors['password']" class="text-red-600 text-xs">{{ fieldErrors['password'] }}</span>
                        <p class="text-xs text-slate-500">Use at least 8 characters, including a letter and a number.</p>
                    </label>

                    <label class="space-y-1 block">
                        <span class="text-sm text-slate-600">Confirm Password</span>
                        <div class="relative">
                            <input
                                formControlName="confirm_password"
                                [type]="showConfirmPassword ? 'text' : 'password'"
                                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 pr-11 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            />
                            <button
                                type="button"
                                (click)="showConfirmPassword = !showConfirmPassword"
                                class="absolute inset-y-0 right-2 flex items-center justify-center rounded-md px-2 text-slate-500 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#6e9bad]/30"
                                [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
                                [attr.aria-pressed]="showConfirmPassword"
                            >
                                <lucide-icon [name]="showConfirmPassword ? 'eye-off' : 'eye'" class="h-4 w-4"></lucide-icon>
                            </button>
                        </div>
                        <span *ngIf="fieldErrors['confirm_password']" class="text-red-600 text-xs">{{ fieldErrors['confirm_password'] }}</span>
                    </label>

                    <label class="flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
                        <input
                            [(ngModel)]="acceptedPolicies"
                            [ngModelOptions]="{ standalone: true }"
                            type="checkbox"
                            class="mt-1 h-4 w-4 accent-[color:var(--primary)]"
                        />
                        <span>
                            I agree to the <a routerLink="/terms" (click)="$event.stopPropagation()" class="font-semibold text-[color:var(--primary)] hover:underline">Terms of Service</a> and <a routerLink="/privacy" (click)="$event.stopPropagation()" class="font-semibold text-[color:var(--primary)] hover:underline">Privacy Policy</a>.
                            By creating your account, you confirm the submitted information is accurate, lawfully provided, and authorized for use, and you consent to electronic communications related to your account and platform operations.
                        </span>
                    </label>
                    <span *ngIf="fieldErrors['policy_acceptance']" class="text-red-600 text-xs">{{ fieldErrors['policy_acceptance'] }}</span>

                    <button
                        type="submit"
                        [disabled]="loading"
                        class="w-full bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-[color:var(--primary-foreground)] h-11 font-semibold rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                    >
                        <lucide-icon *ngIf="loading" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                        <span>{{ loading ? 'Creating account...' : 'Sign Up as Investor' }}</span>
                    </button>

                    <p *ngIf="message" class="text-sm text-emerald-700 text-center">{{ message }}</p>
                    <p *ngIf="error" class="text-sm text-red-600 text-center">{{ error }}</p>
                </form>

                <div *ngIf="showEmailModal" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 px-4">
                    <div class="relative w-full max-w-md rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-6 text-[color:var(--foreground)] shadow-2xl">
                        <button
                            type="button"
                            (click)="closeModal()"
                            class="absolute right-3 top-3 rounded-full bg-slate-100 p-2 text-slate-700 hover:bg-slate-200"
                        >
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>

                        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-[color:var(--secondary)] border border-[color:var(--border)] text-[color:var(--primary)] mb-4">
                            <lucide-icon name="mail" class="h-6 w-6"></lucide-icon>
                        </div>

                        <h3 class="text-xl font-semibold">Verify your email</h3>
                        <ng-container *ngIf="emailSent !== false; else emailSendFailed">
                            <p class="mt-2 text-sm text-slate-600">
                                We sent a verification link to <span class="font-semibold">{{ submittedEmail }}</span>. Click it to activate your account and sign in.
                            </p>
                        </ng-container>
                        <ng-template #emailSendFailed>
                            <p class="mt-2 text-sm text-slate-600">
                                Your account was created, but we couldn’t send the verification email to <span class="font-semibold">{{ submittedEmail }}</span>.
                            </p>
                            <p class="mt-2 text-xs text-slate-500">
                                Try “Resend Email”. If it still doesn’t arrive, check spam/quarantine or contact support.
                            </p>
                        </ng-template>

	                        <div class="mt-6 grid grid-cols-2 gap-2">
	                            <button
	                                type="button"
	                                (click)="resendEmail()"
	                                [disabled]="resendLoading || !signupSessionId"
	                                class="w-full rounded-lg border border-slate-200 bg-white px-4 py-2 text-slate-700 font-semibold hover:bg-slate-50 disabled:opacity-60"
	                            >
	                                <lucide-icon *ngIf="resendLoading" name="loader-2" class="h-4 w-4 animate-spin inline-block mr-2"></lucide-icon>
	                                Resend Email
                            </button>
                            <button
                                type="button"
                                (click)="closeModal()"
                                class="w-full rounded-lg bg-[color:var(--primary)] px-4 py-2 text-[color:var(--primary-foreground)] font-semibold hover:bg-[color:var(--primary-hover)] transition-colors"
                            >
	                                {{ returnUrl ? 'Continue' : 'Close' }}
                            </button>
                        </div>

                        <p *ngIf="resendMessage" class="mt-3 text-xs text-emerald-700">{{ resendMessage }}</p>
                    </div>
                </div>
            </div>
        </div>
    
